export default function checkHasCorporation({ user }) {
    return !user || user?.corporations.length > 0;
}
